import { useIsAuthenticated } from "@azure/msal-react";
import { NavItems } from "@helpers/navigation";
import { Route, Routes } from "react-router-dom";
import { Checkout } from "./checkout";
import { PurchaseCompleted } from "./purchaseCompleted";
import { PurchasePricing } from "./purchasePricing";

export const PurchaseLanding = (): JSX.Element => {
    const isAuthenticated = useIsAuthenticated();

    return (
        <>
            {isAuthenticated ? (
                <Routes>
                    <Route path={"*"} element={<PurchasePricing />} />
                    <Route path={NavItems.Purchase.Pricing.relativePath} element={<PurchasePricing />} />
                    <Route path={NavItems.Purchase.Checkout.relativePath} element={<Checkout />} />
                    <Route path={NavItems.Purchase.SignupCheckout.relativePath} element={<Checkout />} />
                    <Route path={NavItems.Purchase.PurchaseCompleted.relativePath} element={<PurchaseCompleted />} />
                </Routes>
            ) : (
                <Routes>
                    <Route path={"*"} element={<PurchasePricing />} />
                    <Route path={NavItems.Purchase.Pricing.relativePath} element={<PurchasePricing />} />
                    <Route path={NavItems.Purchase.PurchaseCompleted.relativePath} element={<PurchaseCompleted />} />
                </Routes>
            )}
        </>
    );
};
